import { render, staticRenderFns } from "./phoneSure.vue?vue&type=template&id=3cd8991f&scoped=true&"
import script from "./phoneSure.vue?vue&type=script&lang=js&"
export * from "./phoneSure.vue?vue&type=script&lang=js&"
import style0 from "./phoneSure.vue?vue&type=style&index=0&id=3cd8991f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd8991f",
  null
  
)

export default component.exports